import {Injectable} from '@angular/core';
import {LaboratoryDocumentsNamespace} from '@components/laboratory-documents/laboratory-documents.namespace';
import DocumentTypeEnum = LaboratoryDocumentsNamespace.DocumentTypeEnum;
import {SelectValueInterface} from '@interfaces/select-value.interface';

@Injectable()
export class LaboratoryDocumentsTypesProvider {
    public data: LaboratoryDocumentsTypesSelectValueInterface[] = [
        {id: DocumentTypeEnum.attestation,    title: 'Свидетельство об аттестации'},
        {id: DocumentTypeEnum.iiiLicense,     title: 'Лицензия на право использования источников ионизирующего излучения'},
        {id: DocumentTypeEnum.sanitation,     title: 'Санитарно-эпидемиологическое заключение'},
        {id: DocumentTypeEnum.rostehLicense,  title: 'Лицензия Ростехнадзора'},
        {id: DocumentTypeEnum.custom,         title: 'Свой документ'},
    ];
}

export type LaboratoryDocumentsTypesSelectValueInterface = SelectValueInterface<DocumentTypeEnum>;
